import axios from 'axios';

const Axios = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  timeout: 15000, // 15 seconds
  withCredentials: true, // This ensures the httpOnly cookie is always sent
});

/* =========================
   REQUEST INTERCEPTOR
   ========================= */
Axios.interceptors.request.use(
  (config) => {
    if (import.meta.env.DEV) {  }
    return config;
  },
  (error) => Promise.reject(error)
);

/* =========================
   RESPONSE INTERCEPTOR
   ========================= */
Axios.interceptors.response.use(
  (response) => response,
  (error) => {
    /* 🔴 1. Request timeout */
    if (error.code === 'ECONNABORTED') {
      console.error('⏱ Request timeout');
      return Promise.reject({
        message: 'Request timed out. Please try again.',
        type: 'TIMEOUT',
      });
    }

    /* 🔴 2. No internet / server unreachable */
    if (!error.response) {
      console.error('🌐 Network error / Server unreachable');
      return Promise.reject({
        message: 'Network error. Check your internet connection.',
        type: 'NETWORK',
      });
    }

    /* 🔴 3. Backend responded with error */
    const status = error.response.status;
    const originalRequestUrl = error.config?.url || '';

    // 🟢 Smart Automatic Logout
    if (status === 401) {
      
      // 1. IGNORE LOGIN/OTP ROUTES! Let the component handle the error and show the toast.
      // (This safely catches your '/api/admin/auth/login' route too since it contains '/login')
      if (originalRequestUrl.includes('/login') || originalRequestUrl.includes('/verify-otp')) {
        return Promise.reject(error); 
      }

      console.error('🔐 Unauthorized - Cookie expired or invalid');
      
      // 🟢 CHECK WHO WAS LOGGED IN
      const isAdmin = !!localStorage.getItem('adminData') || originalRequestUrl.includes('/admin');
      const isExpert = !!localStorage.getItem('expertCode');

      if (isAdmin) {
        // 1. Wipe Admin Data
        localStorage.removeItem('adminData');
        // 2. Send to Admin Login Page
        window.location.href = '/admin/login';
      } else if (isExpert) {
        // 1. Wipe Expert Data
        localStorage.removeItem('expertCode');
        localStorage.removeItem('expertName');
        // 2. Send to Expert Login
        window.location.href = '/expert-login';
      } else {
        // 1. Wipe User Data
        localStorage.removeItem('user_code');
        localStorage.removeItem('user_name');
        localStorage.removeItem('user_email');
        // 2. Send to User Login
        window.location.href = '/user-login';
      }
    }

    if (status === 500) {
      console.error('💥 Server error');
    }

    return Promise.reject(error);
  }
);

export default Axios;